import { render, staticRenderFns } from "./uploadBtn.vue?vue&type=template&id=36b4f4e5&"
import script from "./uploadBtn.vue?vue&type=script&lang=js&"
export * from "./uploadBtn.vue?vue&type=script&lang=js&"
import style0 from "./uploadBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports